import { Injectable } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import flatten from 'lodash-es/flatten';
import mapValues from 'lodash-es/mapValues';
import uniq from 'lodash-es/uniq';
import { EAttrSet, Product } from '../catalog/product/product.decorator';
import { NFurnitureAssembly } from '../module/furniture-assembly/furniture-assembly.namespace';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {

        interface BasketData {
            protection_plan_ids?: {
                [key: number]: {
                    [key: number]: number;
                };
            };
            assembly?: {
                garden?: NFurnitureAssembly.IBasketDataConfigurationItem;
                sofa?: NFurnitureAssembly.IBasketDataConfigurationItem;
            };
        }

        interface Totals {
            assembly?: number;
            discount_success_message?: string[];
            discounts_applied?: number;
        }
    }
}


@Injectable({
    providedIn: 'root'
})
export class LocalBasket extends Basket {
    get protectionPlansIds(): number[] {
        const ids = this.data?.protection_plan_ids;
        if (ids && !Array.isArray(ids)) {
            return uniq(flatten(Object.values(mapValues(ids, id => Object.values(id)))));
        }
        return [];
    }

    get hasGardenAssembly(): BasketItem<Product<IProductDataV3>> | undefined {
        return this.items.find(item => item.product?.data?.attribute_set === EAttrSet.assemblyPlan) as BasketItem<Product<IProductDataV3>>;
    }
}
